import settlementBatch from './settlementBatch';
import statements from './statements';
import settleSummary from './settleSummary';
import rateConfig from './rateConfig';

export default {
  ...settlementBatch,
  ...statements,
  ...settleSummary,
  ...rateConfig,
};
